/**
 * Відкритий місяць — один на всі таблиці.
 *
 * Кожна таблиця тримала свій, і перехід із харчування в наряди повертав на
 * поточний місяць: діловод, що звіряв вересень, щоразу гортав назад. Тепер
 * обраний місяць лишається, доки його не змінять, на всіх таблицях одразу.
 * Перезавантаження сторінки повертає до поточного — як і замок минулих днів.
 */

import { create } from 'zustand';

export interface YearMonth {
  y: number;
  /** Місяць від нуля, як у `Date`. */
  m: number;
}

interface MonthState {
  month: YearMonth;
  setMonth: (month: YearMonth) => void;
}

const now = new Date();

export const useMonth = create<MonthState>(set => ({
  month: { y: now.getFullYear(), m: now.getMonth() },
  setMonth: month => set({ month }),
}));
